import lightbox from '@js/components/lightbox';
import popup from '@js/components/popup';
import cookieNotice from '../components/cookie-notice';

export default {
  init() {
    lightbox.init();
    popup.init();
    this.events();
    cookieNotice.init();

    this.mobileReadyMenu();
    $(window).on('resize', this.mobileReadyMenu);
  },

  events() {
    // Open menu
    $('body').on('click', '.js-toggle-menu', (e) => {
      const btnEl = $(e.currentTarget);

      $('html').toggleClass('no-scroll');
      $('.site-header').toggleClass('site-header--mobile-open');
      btnEl.children('.burger').toggleClass('burger--open');

      if ($('.site-header').hasClass('site-header--mobile-open')) {
        btnEl.children('.site-header-toggle__text').text(btnEl.data('close'));
      } else {
        btnEl.children('.site-header-toggle__text').text(btnEl.data('open'));
      }
    });

    // Open header submenu
    $('body').on(
      'click',
      '.header-main-menu .menu-item-has-children > a',
      (e) => {
        if ($(window).width() > 1100) {
          return;
        }

        e.preventDefault();
        const subMenu = $(e.currentTarget).siblings('.sub-menu');

        $('.sub-menu').css({
          overflowY: 'hidden',
        });

        subMenu.addClass('sub-menu--open').css({
          overflowY: 'auto',
        });
      }
    );

    // Close header submenu
    $('body').on('click', '.menu-item__back', (e) => {
      e.preventDefault();

      const subMenu = $(e.currentTarget).parent().parent('.sub-menu');
      subMenu.removeClass('sub-menu--open');
      subMenu.css({
        overflowY: 'hidden',
      });

      const topMenu = subMenu.closest('.sub-menu--open');
      if (topMenu.length) {
        topMenu.css({
          overflowY: 'auto',
        });
      }
    });

    // Toggle FAQ item.
    $('body').on('click', '.faq-item__head', (e) => {
      const btn = $(e.currentTarget);
      // Close others
      btn.closest('.faq-item').siblings().removeClass('open');
      btn.closest('.faq-item').siblings().find('.faq-item__content').slideUp();

      // Toggle current
      btn.closest('.faq-item').toggleClass('open');
      btn.closest('.faq-item').find('.faq-item__content').slideToggle();
    });

    // Toggle search
    $('.header-toggle-search').on('click', () => {
      $('.header-search-form').toggleClass('open');
      $('.header-search-form__input').focus();
    });

    // Close on escape.
    $(document).on('keyup', function (e) {
      if (e.key == 'Escape') {
        $('.sheader-earch-form').removeClass('open');
      }
    });
    // Close on click outside.
    $(document).mouseup(function (e) {
      var container = $('.header-search-wrap');

      if (!$('.header-search-form').hasClass('open')) {
        return;
      }

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('.header-search-form').removeClass('open');
      }
    });
  },

  /**
   * Adds back item to header main menu
   */
  mobileReadyMenu() {
    $('.menu-item--back').remove();

    if ($(window).width() > 1100) {
      return;
    }

    $('.header-main-menu .menu-item-has-children').each((_i, item) => {
      const menuItemEl = $(item);
      const itemEl = menuItemEl.children('a');
      const submenuEl = menuItemEl.children('.sub-menu');

      submenuEl.prepend(`<li class="menu-item menu-item--back">
      <button class="btn menu-item__back" type="button" aria-label="Back"></button>
      <a href="${itemEl.attr('href')}">${itemEl.text()}</a>
      </li>`);
    });
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
